import React from 'react';
import { Check, Sparkles } from 'lucide-react';

const tiers = [
  {
    name: 'Growth Plan',
    price: 'RM 399',
    period: '/ month',
    strike: 'RM 999',
    desc: 'For growing brands.',
    features: [
      '10,000 AI messages / month',
      '5 members / users',
      '3 channels (WhatsApp, IG, Web, etc.)',
      'Visual CRM pipeline — included',
      '3,000 active contacts',
      'Knowledge base + Google Drive sync',
      'Email support',
    ],
    cta: 'Start with Growth',
    highlight: false,
  },
  {
    name: 'Professional Plan',
    price: 'RM 999',
    period: '/ month',
    strike: 'RM 1,999',
    desc: 'For growing brands operating across every channel.',
    features: [
      '30,000 AI messages / month',
      '10 members / users',
      '8 channels (all major platforms)',
      'Visual CRM pipeline — included',
      '10,000 active contacts',
      'Appointment booking + Google Calendar',
      'Channel-specific prompts',
      'Priority support',
    ],
    cta: 'Start with Professional',
    highlight: true,
    badge: 'Most popular',
  },
  {
    name: 'Enterprise Plan',
    price: "Let's discuss",
    period: '',
    desc: 'For brands needing private auth, SQL access and dedicated infra.',
    features: [
      'Everything in Professional',
      'Private Channel Access',
      'MySQL / PostgreSQL / Mongo / SQLite',
      'Unlimited members / users + SSO',
      'Dedicated account manager',
    ],
    cta: 'Talk to sales',
    highlight: false,
  },
];

export default function Pricing() {
  return (
    <section id="pricing" className="pricing">
      <div className="container">
        <div className="pricing__head reveal">
          <span className="eyebrow">Pricing</span>
          <h2 className="pricing__title">Simple plans. Predictable pricing.</h2>
          <p className="pricing__desc">
            Pick a plan that fits your team. Upgrade as your conversations grow.
          </p>
        </div>

        <div className="pricing__grid">
          {tiers.map((t, i) => (
            <div
              key={t.name}
              className={`tier reveal ${t.highlight ? 'tier--hl' : ''}`}
              style={{ transitionDelay: `${i * 80}ms` }}
            >
              {t.badge && (
                <div className="tier__badge">
                  <Sparkles size={12} /> {t.badge}
                </div>
              )}
              <div className="tier__name">{t.name}</div>
              <div className="tier__price">
                <span className="tier__amount">{t.price}</span>
                {t.period && <span className="tier__period">{t.period}</span>}
              </div>
              {t.strike && (
                <div className="tier__strikeRow">
                  <span className="tier__strike">{t.strike}</span>
                  <span className="tier__save">Save {Math.round((1 - parseInt(t.price.replace(/[^0-9]/g, ''), 10) / parseInt(t.strike.replace(/[^0-9]/g, ''), 10)) * 100)}%</span>
                </div>
              )}
              <p className="tier__desc">{t.desc}</p>
              <ul className="tier__list">
                {t.features.map((f) => (
                  <li key={f}><Check size={16} /> {f}</li>
                ))}
              </ul>
              <a
                href="#start"
                className={`btn ${t.highlight ? 'btn--primary' : 'btn--ghost'} btn--block`}
              >
                {t.cta}
              </a>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
